module.exports = __webpack_public_path__ + "static/media/no-img-available.be940c4b.jpg";